import React from 'react'
import Section from './Section'
import Section1 from './Section1'
import NavBar4 from '../../layout/Navbar4'

const Index2 = () => {
  return (
    <React.Fragment>
      <NavBar4 />
      <Section />
      <Section1 />
    </React.Fragment>
  )
}

export default Index2